/** The first LETTER in a string (A-Z, case-insensitive) — skips any leading
 * digit/punctuation/symbol so a value like "(Test) Corp" or "3M Ventures"
 * never surfaces the parenthesis or digit as a monogram initial. */
const firstLetter = (word = '') => {
  const m = String(word).match(/[A-Za-z]/);
  return m ? m[0].toUpperCase() : '';
};

/**
 * Avatar/monogram initials — one letter per "word" (splitting on whitespace,
 * plus "@" and "." so an email resolves the same way as a name), up to
 * `maxParts`. Always a real letter, never a digit or symbol: a word with no
 * letter at all (e.g. a lone "123") is skipped rather than contributing one.
 * Returns `fallback` when nothing usable is found.
 *
 * The single shared implementation for every avatar/monogram in the app —
 * import this instead of writing another local `initialsOf`.
 */
export const getInitials = (value, maxParts = 2, fallback = '?') => {
  const words = String(value || '').trim().split(/[\s@.]+/).filter(Boolean);
  const letters = [];
  for (const word of words) {
    const letter = firstLetter(word);
    if (letter) letters.push(letter);
    if (letters.length >= maxParts) break;
  }
  return letters.length ? letters.join('') : fallback;
};

export default getInitials;
